<div class="grid">
  <div class="col-12 md:col-12 lg:col-12">
    <h1 class="titulo-pagina">{{ 'MENUVISITA.LBL_ADMMENU' | translate}}</h1>
  </div>
</div>

<div class="grid">
  <div class="col-12 md:col-6 lg:col-6 flex gap-2">
    <button type="button" pButton icon="p-icon-add" (click)="new()"
            label="{{'MENUVISITA.BTN_AGRMENU' | translate}}"
            *ngIf="btn.show && menu.agregar"></button>
    <button type="button" pButton icon="p-icon-add" (click)="newSub()"
            label="{{'MENUVISITA.BTN_AGRSUBMENU' | translate}}"
            *ngIf="btnsub.show && menu.agregar"></button>
  </div>
</div>


<div class="grid">
  <div class="col-12 md:col-4 lg:col-4">
    <p-tree id="treeBien" [(value)]="treeProperties" selectionMode="single" [(selection)]="nodeSelected"
            (onNodeSelect)="preSelect($event.node)" [loading]="loadingTree"
            (onNodeExpand)="nodeExpand($event.node)">
      <ng-template let-item pTemplate="default">
        <span>{{ item.label }}</span>
      </ng-template>
    </p-tree>
  </div>
  <div class="col-12 md:col-8 lg:col-8">
    <p-panel header="{{header}}">
      <fieldset>
          <form [formGroup]="formulario" (ngSubmit)="onSubmit()" name="nomForm" novalidate id="idForm">
            <div class="grid" *ngIf="loadingData">
              <div class="col-12 md:col-12 lg:col-12 text-center">
                <i class="fa fa-refresh fa-spin fa-fw"></i>
                <span>{{ 'LBL_CARGANDO' | translate}}...</span>
              </div>
            </div>
            <div *ngIf="!loadingData">

              <div class="grid">
                <div class="col-12 md:col-12 lg:col-12">
                  <div class="div-form">
                    <label>* {{ 'MENUVISITA.LBL_CODMENU' | translate }}</label>
                    <div *ngIf="!menuVisita.idMenuVisita">
                      <input type="text" pInputText id="codigo"
                             name="nomCodigo"
                             autocomplete="off"
                             formControlName="codigo"
                             [maxlength]="10"
                             codigos-reactive
                      >
                      <div class="p-message p-messages-error p-corner-all"
                           *ngIf="submitted && f.codigo.invalid">
                        {{ 'MENUVISITA.LBL_CODMENU' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                      </div>
                    </div>
                    <div *ngIf="menuVisita.idMenuVisita">
                      <label class="falso-combo-texto">{{menuVisita.codigo}}</label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="grid">
                <div class="col-12 md:col-12 lg:col-12">
                  <div class="div-form">
                    <label>* {{ 'LBL_NOMBRE' | translate }}</label>
                    <input type="text" pInputText id="nombre"
                           name="nomNombre"
                           autocomplete="off"
                           formControlName="nombre"
                           [maxlength]="50" required
                           capitalize-reactive
                    >
                    <div class="p-message p-messages-error p-corner-all"
                         *ngIf="submitted && f.nombre.invalid">
                      {{ 'LBL_NOMBRE' | translate }} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="grid">
                <div class="col-12 md:col-3 lg:col-3">
                  <div class="div-form">
                    <p-checkbox formControlName="indicadorHabilitado" binary="true"></p-checkbox>
                    <label class="pl-2">{{'LBL_HABILITADO' | translate}}</label>
                  </div>
                </div>
              </div>
              <div class="grid form-footer-buttons" *ngIf="menu.agregar && menu.editar">
                <div class="form-group col-12 text-center">
                  <a (click)="doCancel(formulario.dirty)" class="cancelar">{{ 'BTN_CANCELAR' | translate }} </a>
                  <button pButton type="submit" formaction="" label="{{ 'BTN_GUARDAR' | translate }}"></button>
                </div>
              </div>
            </div>
          </form>
      </fieldset>
    </p-panel>
  </div>
</div>
<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
